import { createSlice } from '@reduxjs/toolkit';

import { addTramitDocType, deleteForceDeletableTramitAttachment,
    deleteTramitAttachment,
    manualSignTramitAttachment,
    manualSignTramitAttachmentByAjuntament,
    updateTramitAttachment,
    uploadTramitAttachmentByDocNumber,
    uploadTramitAttachmentById,
} from './thunkActions';
import { addExpedientEnquesta } from './thunkActions/enquesta';
import { deleteExpedientAttachment,
    manualSignExpedientAttachment,
    manualSignExpedientAttachmentByAjuntament,
    setSelectedExpedient,
    updateExpedientAttachment,
    uploadExpedientAttachmentById,
} from './thunkActions/expedient';
import { IExpedientState } from './types';

const getInitialState = (): IExpedientState => ({
    selectedExpedient: null,
    selectedExpedientWithSeguiments: null,
    isLoading: false,
    isAttachmentProcessing: false,
});

const expedientSlice = createSlice({
    name: 'expedient',
    initialState: getInitialState(),
    reducers: {
        setSelectedExpedientWithSeguimentsSync: (state, action) => ({ ...state, selectedExpedientWithSeguiments: action.payload }),
        /** Reducer to set selectedTramit from payload */
        setSelectedExpedientSync: (state, action) => ({ ...state, selectedExpedient: action.payload }),
    },
    extraReducers: builder => builder

        .addCase(manualSignExpedientAttachmentByAjuntament.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(manualSignExpedientAttachmentByAjuntament.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(manualSignExpedientAttachmentByAjuntament.fulfilled, (state, action) => ({ ...state, selectedExpedient: action.payload.selectedExpedient, isAttachmentProcessing: false }))

        .addCase(manualSignTramitAttachmentByAjuntament.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(manualSignTramitAttachmentByAjuntament.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(manualSignTramitAttachmentByAjuntament.fulfilled, (state, action) => ({ ...state, selectedExpedient: action.payload.selectedExpedient, isAttachmentProcessing: false }))

        .addCase(manualSignExpedientAttachment.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(manualSignExpedientAttachment.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(manualSignExpedientAttachment.fulfilled, (state, action) => ({ ...state, selectedExpedient: action.payload.selectedExpedient, isAttachmentProcessing: false }))

        .addCase(manualSignTramitAttachment.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(manualSignTramitAttachment.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(manualSignTramitAttachment.fulfilled, (state, action) => ({ ...state, selectedExpedient: action.payload.selectedExpedient, isAttachmentProcessing: false }))

        .addCase(updateTramitAttachment.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(updateTramitAttachment.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(updateTramitAttachment.fulfilled, (state, action) => ({ ...state, selectedExpedient: action.payload.selectedExpedient, isAttachmentProcessing: false }))

        .addCase(updateExpedientAttachment.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(updateExpedientAttachment.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(updateExpedientAttachment.fulfilled, (state, action) => ({ ...state, selectedExpedient: action.payload.selectedExpedient, isAttachmentProcessing: false }))

        .addCase(deleteTramitAttachment.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(deleteTramitAttachment.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(deleteTramitAttachment.fulfilled, (state, action) => ({ ...state, selectedExpedient: action.payload.selectedExpedient, isAttachmentProcessing: false }))

        .addCase(deleteForceDeletableTramitAttachment.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(deleteForceDeletableTramitAttachment.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(deleteForceDeletableTramitAttachment.fulfilled, (state, action) => ({ ...state, selectedExpedient: action.payload.selectedExpedient, isAttachmentProcessing: false }))

        .addCase(addTramitDocType.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(addTramitDocType.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(addTramitDocType.fulfilled, (state, action) => ({ ...state, selectedExpedient: action.payload.selectedExpedient, isAttachmentProcessing: false }))

        .addCase(deleteExpedientAttachment.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(deleteExpedientAttachment.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(deleteExpedientAttachment.fulfilled, (state, action) => ({ ...state, selectedExpedient: action.payload.selectedExpedient, isAttachmentProcessing: false }))

        .addCase(uploadTramitAttachmentByDocNumber.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(uploadTramitAttachmentByDocNumber.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(uploadTramitAttachmentByDocNumber.fulfilled, (state, action) => ({ ...state, selectedExpedient: action.payload.selectedExpedient, isAttachmentProcessing: false }))

        .addCase(uploadTramitAttachmentById.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(uploadTramitAttachmentById.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(uploadTramitAttachmentById.fulfilled, (state, action) => ({ ...state, selectedExpedient: action.payload.selectedExpedient, isAttachmentProcessing: false }))

        .addCase(uploadExpedientAttachmentById.pending, state => ({ ...state, isAttachmentProcessing: true }))

        .addCase(uploadExpedientAttachmentById.rejected, state => ({ ...state, isAttachmentProcessing: false }))

        .addCase(uploadExpedientAttachmentById.fulfilled, (state, action) => ({ ...state, selectedExpedient: action.payload.selectedExpedient, isAttachmentProcessing: false }))

        .addCase(setSelectedExpedient.pending, state => ({ ...state, isLoading: true }))

        .addCase(setSelectedExpedient.rejected, state => ({ ...state, isLoading: false }))

        .addCase(setSelectedExpedient.fulfilled, (state, action) => ({ ...state, selectedExpedient: action.payload, isLoading: false }))

        .addCase(addExpedientEnquesta.pending, state => ({ ...state, isLoading: true }))

        .addCase(addExpedientEnquesta.rejected, state => ({ ...state, isLoading: false }))

        .addCase(addExpedientEnquesta.fulfilled, (state, action) => ({ ...state, selectedExpedient: action.payload, isLoading: false })),
});

export const { setSelectedExpedientSync, setSelectedExpedientWithSeguimentsSync } = expedientSlice.actions;

export const expedient = expedientSlice.reducer;
